import {styled} from '@esgi/ui/theme';
import {Text} from '@esgi/ui/typography';
import {Checkbox, ToggleGroup} from '@esgi/ui/controls';
import {Box, GridBox} from '@esgi/ui/layout';

export const Section = styled(GridBox, {

});

export const Title = styled(Text, {
	padding: '20px 0 12px',
	margin: '0 12px 12px',
	borderBottom: '1px solid $neutral88',
	textAlign: 'center',
	display: 'block',
});

export const ToggleGroupRoot = styled(ToggleGroup.Root, {
	padding: '2px',
	backgroundColor: '$neutral99',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '6px',
	width: '100%',
});

export const ToggleGroupContent = styled(ToggleGroup.Content, {
	width: '100%',
	gridTemplateColumns: '1fr 1fr',
	gap: '2px',
});

export const ToggleGroupItem = styled(ToggleGroup.Item, {
	padding: '8px 20px',
});

export const Label = styled(Text, {
	textAlign: 'center',
});

export const Body = styled(GridBox, {
	gap: '12px',
});

export const CheckboxControl = styled(Checkbox, {
	alignItems: 'center',
	justifyContent: 'flex-start',
	borderRadius: '6px',
	padding: '8px',
});
